import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../../../../packages/JsonQuery';
import { IOffer } from '../../../../types/offer';
import { mlSearchSession } from 'shared/mlSearchSession';

interface ITrackWriteClickParams {
  offer: IOffer;
  position: number;
  jsonQuery: TJsonQuery;
  isEarlyAccess?: boolean;
  source?: string;
}

interface ITrackWriteClickBlockedParams {
  offer: IOffer;
  position: number;
  jsonQuery: TJsonQuery;
  blockType: string;
  source?: string;
}

export function trackWriteClick({ offer, position, jsonQuery, isEarlyAccess = false, source }: ITrackWriteClickParams) {
  const mlSearchSessionGuid = mlSearchSession.getSessionGuid(jsonQuery);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'send_message',
    label: offer.gaLabel,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        mlSearchSessionGuid,
        /* istanbul ignore next */
        opponent_id: offer.user?.cianUserId,
        type: 'Open_listing_agent_block',
        is_early_access: isEarlyAccess,
        source,
      },
    },
  });
}

export function trackWriteClickBlocked({
  offer,
  position,
  jsonQuery,
  blockType,
  source,
}: ITrackWriteClickBlockedParams) {
  const mlSearchSessionGuid = mlSearchSession.getSessionGuid(jsonQuery);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'send_message_blocked_early_access',
    label: offer.gaLabel,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        mlSearchSessionGuid,
        opponent_id: offer.user?.cianUserId,
        type: 'Open_listing_agent_block',
        block_type: blockType,
        source,
      },
    },
  });
}
